import React from "react";
import ChatContainer from "./components/ChatContainer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <ChatContainer />
    </div>
  );
}

export default App;
